import React from 'react';
import parse from 'html-react-parser';

export const TutorialComponent = ({ tutorial }) => {
  const htmlString = tutorial;
  return <div>{parse(htmlString)}</div>;
};
